import '@babel/polyfill';

import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store'
import wx from 'weixin-js-sdk'

Vue.config.productionTip = false

import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
Vue.use(Antd)

import './index.less';
import './permission'
import './utils/filters'
import './utils/directives' //全局自定义指令

import Storage from 'vue-ls';
let options = {
  namespace: '',
  name: 'ls',
  storage: 'local',
};
Vue.use(Storage, options);


import infiniteScroll from 'vue-infinite-scroll'
Vue.use(infiniteScroll)

Vue.use(require('vue-wechat-title'))



import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)


Vue.component('spin', () => import('./components/spin'))
Vue.component('my-spin', () => import('./components/my-spin'))
Vue.component('device-certificate', () => import('./components/device-certificate'))
Vue.component('device-qrcode', () => import('./components/device-qrcode'))
Vue.component('empty-box', () => import('./components/empty-box'))
Vue.component('count-total', () => import('./components/count-total'))
Vue.component('query-form', () => import('./components/query-form'))
Vue.component('my-list', () => import('./components/my-list'))
Vue.component('my-list-item', () => import('./components/my-list-item'))


// Vue.prototype.$web_url = 'http://onlinetest.aihua-ai.cn/'//网页部署地址，扫二维码跳转到这里
Vue.prototype.$web_url = 'https://auth.aihua-ai.cn/'
Vue.prototype.$app_id = 'wxb86ae4d13666193a'
Vue.prototype.$wx = wx



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
